import { render, staticRenderFns } from "./gzzoc-ckd2.vue?vue&type=template&id=21777ef3&scoped=true&lang=pug&"
import script from "./gzzoc-ckd2.vue?vue&type=script&lang=js&"
export * from "./gzzoc-ckd2.vue?vue&type=script&lang=js&"
import style0 from "./gzzoc-ckd2.vue?vue&type=style&index=0&id=21777ef3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21777ef3",
  null
  
)

export default component.exports